import { useCallback, useMemo, useState } from "react";

export default function useStateArray<T>(): [
  T[],
  (item: T, index: number) => void,
] {
  const [items, setItems] = useState<T[]>([]);

  const updateItem = useCallback((item: T, index: number) => {
    setItems((oldItems) => {
      if (oldItems[index] !== item) {
        const clonedItems = [...oldItems];
        clonedItems[index] = item;
        return clonedItems;
      }
      return oldItems;
    });
  }, []);

  return useMemo(() => [items, updateItem], [items, updateItem]);
}
